import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { BrandLoader } from "../components/ui/Logo/BrandLoader";
import { useAuth } from "../firebase/AuthProvider";

const SuperAdminRoute = () => {
  const { currentUser, currentRoles, isLoading } = useAuth();

  if (isLoading) {
    return <BrandLoader fullScreen />;
  }

  // If not logged in at all, kick to login
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // Determine if the user has the Super Admin role. 
  // NOTE: Adjust the string "SUPER_ADMIN" to match exactly how it is spelled in your database/state!
  const isSuperAdmin = currentRoles?.some(
    (role) => role.name === "SUPER ADMIN" || role.name === "SuperAdmin"
  );

  // If they aren't a Super Admin, kick them to a safe default page (like home or dashboard)
  if (!isSuperAdmin) {
    console.warn("SuperAdminRoute: Access denied. User is not a Super Admin.");
    return <Navigate to="/home" replace />; 
  }

  // If they pass the checks, render the child routes
  return <Outlet />;
};

export default SuperAdminRoute;
